<!-- Sales Invoice Details (F3). Chrome comes from styles/components/_dialogs.scss. -->
<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  (onShow)="onDialogShow()"
  (onHide)="onDialogHide()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  styleClass="pos-dlg pos-dlg-xl premium-dialog dense-invoice-dialog"
  [focusOnShow]="false"
>
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">Sales Invoice Details</h3>
      <p class="premium-subtitle">
        Select an invoice to process returns or exchanges
      </p>
    </div>
    <button
      class="premium-close-btn"
      (click)="onCloseClick()"
      type="button"
      aria-label="Close sales invoice details"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="premium-body invoice-body">
    <div class="dense-toolbar">
      <div class="search-input-wrapper">
        <i class="pi pi-search search-icon"></i>
        <input
          type="text"
          pInputText
          [formControl]="searchControl"
          placeholder="Search by Invoice No or Customer Number"
          class="dense-search-input"
        />
        <!-- Spinner: loading the return list -->
        <i
          *ngIf="isLoadingInvoices"
          class="pi pi-spin pi-spinner loading-spinner"
        ></i>
        <!-- Spinner: fetching full details after row-click (salesreturndetails API) -->
        <i
          *ngIf="isLoadingDetails"
          class="pi pi-spin pi-spinner loading-spinner"
          title="Loading invoice details..."
        ></i>
      </div>

      <span class="stat-pill">
        <i class="pi pi-list"></i>
        Total: {{ totalCount }}<span *ngIf="!hasMoreData">&nbsp;(all)</span>
      </span>
    </div>

    <div class="dense-table-container">
      <p-table
        [value]="dialogInvoiceList"
        [scrollable]="true"
        scrollHeight="calc(85vh - 300px)"
        [loading]="isLoadingInvoices"
        styleClass="dense-table"
        [rowHover]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="col-expand-invoice"></th>
            <th class="col-nowrap">Invoice No</th>
            <th>Customer</th>
            <th class="col-nowrap">Invoice Date</th>
            <th class="text-right">Subtotal</th>
            <th class="text-right">Tax Amount</th>
            <th class="text-right">Total</th>
            <th class="text-right">Grand Total</th>
            <th class="text-center" *ngIf="showLoyaltyColumn">Loyalty</th>
            <th class="text-center">Return Status</th>
          </tr>
        </ng-template>

        <!-- Skeleton Loading -->
        <ng-template pTemplate="loadingbody">
          <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]">
            <td><p-skeleton shape="circle" size="1.2rem"></p-skeleton></td>
            <td><p-skeleton width="80%" height="1rem"></p-skeleton></td>
            <td><p-skeleton width="60%" height="1rem"></p-skeleton></td>
            <td><p-skeleton width="70%" height="1rem"></p-skeleton></td>
            <td class="text-right">
              <p-skeleton
                width="60%"
                height="1rem"
                styleClass="ml-auto"
              ></p-skeleton>
            </td>
            <td class="text-right">
              <p-skeleton
                width="60%"
                height="1rem"
                styleClass="ml-auto"
              ></p-skeleton>
            </td>
            <td class="text-right">
              <p-skeleton
                width="60%"
                height="1rem"
                styleClass="ml-auto"
              ></p-skeleton>
            </td>
            <td class="text-right">
              <p-skeleton
                width="70%"
                height="1.1rem"
                styleClass="ml-auto"
              ></p-skeleton>
            </td>
            <td class="text-center" *ngIf="showLoyaltyColumn">
              <p-skeleton
                width="40%"
                height="1rem"
                styleClass="mx-auto"
              ></p-skeleton>
            </td>
            <td class="text-center">
              <p-skeleton
                width="70px"
                height="1.5rem"
                styleClass="mx-auto border-round-xl"
              ></p-skeleton>
            </td>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-row>
          <tr
            (click)="onInvoiceRowClick(row)"
            [class.selected-row]="selectedInvoiceForDialog === row"
            class="data-row"
          >
            <td>
              <div
                class="custom-radio"
                [class.checked]="selectedInvoiceForDialog === row"
              >
                <div class="inner-circle"></div>
              </div>
            </td>

            <td class="col-nowrap invoice-no">{{ row.invoice.invoiceno }}</td>
            <td>
              <div class="customer-cell" [title]="row.invoice.name || ''">
                <span class="customer-name">{{ row.invoice.name }}</span>
                <span class="customer-id">{{ row.invoice.user_id }}</span>
              </div>
            </td>
            <td class="col-nowrap">
              {{ row.invoice.invoicedate | date: "MMM dd, yyyy" }}
            </td>

            <td class="text-right col-nowrap">
              {{ row.invoice.subtotal | number: "1.2-2" }}
            </td>
            <td class="text-right col-nowrap">
              {{ row.invoice.taxamount | number: "1.2-2" }}
            </td>
            <td class="text-right col-nowrap">
              {{ row.invoice.total | number: "1.2-2" }}
            </td>
            <td class="text-right col-nowrap amount-strong">
              {{ row.invoice.grandtotal | number: "1.2-2" }}
            </td>

            <td class="text-center" *ngIf="showLoyaltyColumn">
              <span *ngIf="row.invoice.redeempointamt > 0; else noLoyalty"
              >
                {{ row.invoice.redeempoints }}
              </span>
              <ng-template #noLoyalty
                ><span class="dash-muted">-</span></ng-template
              >
            </td>

            <td class="text-center">
              <div
                class="status-badge"
                [ngClass]="
                  row.invoice.exchangestatus === 0
                    ? 'status-eligible'
                    : 'status-returned'
                "
              >
                {{ row.invoice.exchangestatus === 0 ? "Eligible" : "Returned" }}
              </div>
            </td>
          </tr>
        </ng-template>

        <!-- Empty State -->
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="showLoyaltyColumn ? 10 : 9">
              <div class="invoice-empty">
                <i class="pi pi-search"></i>
                <p class="invoice-empty__title">No invoices found</p>
                <p class="invoice-empty__hint">
                  Try another invoice number or customer number.
                </p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- ── Infinite Scroll Indicators ── -->

      <!-- Spinner shown while loading the next page -->
      <div *ngIf="isLoadingMore" class="load-more-indicator">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading more invoices…</span>
      </div>

      <!-- End-of-list message when all pages have been fetched -->
      <div
        *ngIf="!hasMoreData && !isLoadingInvoices && dialogInvoiceList.length > 0"
        class="end-of-list-indicator"
      >
        <i class="pi pi-check-circle"></i>
        <span>All {{ dialogInvoiceList.length }} records loaded</span>
      </div>
    </div>
  </div>

  <div class="premium-footer">
    <button
      class="premium-btn premium-btn-secondary"
      (click)="onCloseClick()"
      type="button"
    >
      Close
    </button>
  </div>
</p-dialog>
